import React from 'react';
import '../../assets/styles/dashboard.css';
import DeviceInfoCard from './deviceInfoCard';
import CaseInfoCard from './caseInfoCard';
import SmsCapabilityCard from './smsCapabilityCard';
import LocationTrackingCard from './locationTrackingCard';
import CallFunctionalityCard from './callFunctionalityCard';
import MessageHistoryCard from './messageHistoryCard';
import VoicemailCard from './voicemailCard';
import SubscriptionCard from './subscriptionCard';
import CustPreferancesCard from './custPreferancesCard';


function Dashboard() {

  return (
    <section className="cd-dashboard" aria-labelledby="dashboard-heading">
      <h1 id="dashboard-heading">User Dashboard</h1>
      <div className="cd-card-grid" role="region" aria-label="Dashboard overview cards">
        <DeviceInfoCard />
        <CaseInfoCard />
        <LocationTrackingCard />
        {/* <CallFunctionalityCard /> */}
        <SubscriptionCard />
      </div>
    </section>
  );
}

export default Dashboard;
